import { useCallback, useEffect } from 'react'
import { batch, useSignal } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import { WEBBACK_V2_API } from '@constants'
import { commonFiltersValue, isLoadingCommonFilters, isSystemBusy, userData } from '@signals'
import { monitoringResultsIsEmpty, monitoringResultsReportFormSubmittedFilters, monitoringResultsDataLimit, monitoringResultsScopeFilters } from "../@signals"


export default function useMonitoringResultsTableFilters() {
    const showTable = useSignal(true)
    const monitoringTableData = useSignal({})
    const monitoringTableDates = useSignal({})
    const monitoringTableSites = useSignal({})
    const monitoringTableMetric = useSignal('')
    const monitoringTableFilledData = useSignal(false)
    const monitoringTableCountrySelected = useSignal('')
    const monitoringTableCountries = useSignal([])

    const showMinMaxPrices = userData.value?.customerID === 14

    const handleSubmit = () => {
        monitoringResultsIsEmpty.value = false
        postSubmit(`${WEBBACK_V2_API}/monitoring/results/context`, commonFiltersValue.value).then(res => {
            monitoringResultsReportFormSubmittedFilters.value = commonFiltersValue.peek()
            monitoringResultsDataLimit.value = res.limitResults
            const firstCountry = res.countries?.[0]?.country || ''
            if (!res.data?.[firstCountry]?.length)
                monitoringResultsIsEmpty.value = true
            monitoringTableData.value = res.data
            monitoringTableDates.value = res.dates
            monitoringTableMetric.value = res.metric
            monitoringTableSites.value = res.sites
            monitoringTableFilledData.value = !!res.filledData
            monitoringTableCountries.value = res.countries
            monitoringTableCountrySelected.value = firstCountry
            monitoringResultsScopeFilters.value.sku = res.skus
            monitoringResultsScopeFilters.value.retailer = Object.values(res.sites).flat()
            isLoadingCommonFilters.value = false
        }).catch(() => {
            isLoadingCommonFilters.value = false
            isSystemBusy.value = true
        })
    }

    useEffect(() => {
        if (isLoadingCommonFilters.value) batch(() => {
            handleSubmit()
        })
    }, [isLoadingCommonFilters.value])

    const handleChangeCountrySelected = useCallback(newValue => batch(() => {
        showTable.value = false
        monitoringTableCountrySelected.value = newValue
        setTimeout(() => showTable.value = true, 200)
    }), [])

    return {
        showTable: showTable.value,
        monitoringTableData: monitoringTableData.value?.[monitoringTableCountrySelected.value] || [],
        monitoringTableDates: monitoringTableDates.value?.[monitoringTableCountrySelected.value] || [],
        monitoringTableSites: monitoringTableSites.value?.[monitoringTableCountrySelected.value] || [],
        monitoringTableMetric: monitoringTableMetric.value,
        monitoringTableFilledData: monitoringTableFilledData.value,
        monitoringTableCountries: monitoringTableCountries.value,
        monitoringTableCountrySelected: monitoringTableCountrySelected.value,
        showMinMaxPrices,

        handleChangeCountrySelected
    }
}